var _circle, _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#FA9418"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 13.7143,
    height: 13.7143,
    transform: "translate(5.14307 5.48206)",
    fill: "#FA9418"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8574 12.3392C18.8574 13.2859 18.0898 14.0534 17.1431 14.0534H6.85735C5.91058 14.0534 5.14307 13.2859 5.14307 12.3392C5.14307 11.3924 5.91058 10.6249 6.85735 10.6249H17.1431C18.0898 10.6249 18.8574 11.3924 18.8574 12.3392Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.064bd5acb29d98fe7ce62570186f505e.svg";
export { ForwardRef as ReactComponent };